<template>
  <header class="main-header">
    <div class="header-inner">
      <router-link to="/" class="logo-link">
        <img :src="logoUrl" alt="FW Laatzen" class="logo" />
      </router-link>

      <nav class="desktop-nav">
        <router-link
            v-for="item in navItems"
            :key="item.path"
            :to="item.path"
            class="nav-link"
            :class="{ active: $route.path === item.path }"
        >
          {{ item.name }}
          <span class="nav-indicator"></span>
        </router-link>
        <router-link to="/mitgestalten" class="nav-cta">Idee einreichen</router-link>
      </nav>

      <button class="mobile-toggle" @click="menuOpen = !menuOpen" :class="{ open: menuOpen }">
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- Mobile Menu -->
    <div class="mobile-menu" :class="{ open: menuOpen }">
      <div class="mobile-menu-inner">
        <nav class="mobile-nav">
          <router-link
              v-for="item in navItems"
              :key="item.path"
              :to="item.path"
              class="mobile-nav-link"
              @click="menuOpen = false"
          >
            {{ item.name }}
          </router-link>
        </nav>
        <router-link to="/mitgestalten" class="mobile-nav-cta" @click="menuOpen = false">
          Idee einreichen
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
import logoUrl from '@/assets/gfw_logo.png'

export default {
  name: 'AppHeader',
  data() {
    return {
      logoUrl,
      menuOpen: false,
      navItems: [
        { name: 'Ziele', path: '/ziele' },
        { name: 'Mitglieder', path: '/mitglieder' },
        { name: 'Themen', path: '/themen' },
        { name: 'Neuigkeiten', path: '/neuigkeiten' },
        { name: 'Über uns', path: '/ueber-uns' }
      ]
    }
  }
}
</script>

<style scoped>
.main-header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border-bottom: 1px solid rgba(0, 38, 94, 0.1);
}

.header-inner {
  position: relative;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding: 14px 32px;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  flex-shrink: 0;
}

.logo {
  height: 40px;
  width: auto;
}

.desktop-nav {
  display: none;
  gap: 28px;
}

@media (min-width: 768px) {
  .desktop-nav {
    display: flex;
  }
}

.nav-link {
  position: relative;
  padding: 4px 0;
  color: #00265E;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 600;
  transition: color 0.2s ease;
}

.nav-link:hover {
  color: #FA6A01;
}

.nav-link.active {
  color: #FA6A01;
}

.nav-indicator {
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #FA6A01;
  transform: scaleX(0);
  transition: transform 0.2s ease;
}

.nav-link.active .nav-indicator {
  transform: scaleX(1);
}

.nav-cta {
  display: inline-flex;
  align-items: center;
  padding: 5px 18px;
  background: #00265E;
  color: white;
  text-decoration: none;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 700;
  transition: all 0.2s ease;
}

.nav-cta:hover {
  background: #023471;
}

/* Mobile Toggle */
.mobile-toggle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  width: 40px;
  height: 40px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
}

.mobile-toggle span {
  display: block;
  width: 22px;
  height: 2px;
  background: #00265E;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.mobile-toggle.open span:first-child {
  transform: translateY(4px) rotate(45deg);
}

.mobile-toggle.open span:last-child {
  transform: translateY(-4px) rotate(-45deg);
}

@media (min-width: 768px) {
  .mobile-toggle {
    display: none;
  }
}

/* Mobile Menu */
.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #ffffff;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: all 0.4s ease;
}

.mobile-menu.open {
  opacity: 1;
  pointer-events: all;
}

.mobile-menu-inner {
  text-align: center;
}

.mobile-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 48px;
}

.mobile-nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 16px 32px;
  color: #1a1a2e;
  text-decoration: none;
  font-size: 2rem;
  font-weight: 700;
  transition: all 0.3s ease;
  letter-spacing: -0.5px;
}

.mobile-nav-link:hover {
  color: #FA6A01;
}

.mobile-nav-cta {
  display: inline-flex;
  align-items: center;
  padding: 14px 32px;
  background: #00265E;
  color: white;
  text-decoration: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 700;
}

</style>